<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html{
	margin:0;
	padding:0;
	border:0;
  background-color: #f1f1f1;
}

body{
  margin: 0;
  padding:0;
  overflow-x: hidden;
}

.left-popover{
  margin-left: 0 !important;
  background-color: #545c64 !important;
  border: 1px solid #545c64 !important;
  width: 13vw !important;
}

.el-popover__title {
    color: #fff;
    font-size: 1vw;
}

</style>



// WEBPACK FOOTER //
// src/App.vue